import {
  ErrorMessage,
  FrequentFlyerCard,
} from '@dapi/sdk';
import {
  createFrequentFlyerCard,
} from '@dapi/sdk/spec';
import {
  namedTraveler,
} from '../dictionaries/journeyTraveler';

export const frequentFlyerCardSN: FrequentFlyerCard = createFrequentFlyerCard({
  template: {
    travelerId: namedTraveler.id,
    id: '12345678',
    companyCode: 'SN',
    cardNumber: '222016309675385'
  }
});

export const frequentFlyerCardSV: FrequentFlyerCard = createFrequentFlyerCard({
  template: {
    travelerId: namedTraveler.id,
    id: '55555555',
    companyCode: 'SV',
    cardNumber: '12345678'
  }
});

export const ffSVIdentificationAlshehri: FrequentFlyerCard = createFrequentFlyerCard({
  template: {
    travelerId: namedTraveler.id,
    id: '55555555',
    companyCode: 'SV',
    cardNumber: '12064986'
  }
});

export const frequentFlyerCardUX: FrequentFlyerCard = createFrequentFlyerCard({
  template: {
    travelerId: namedTraveler.id,
    id: '11111111',
    companyCode: 'UX',
    cardNumber: '9876543210'
  }
});

export const mockErrorInvalidFrequentFlyerCard: ErrorMessage = {
  code: '36907',
  title: 'INVALID FREQUENT FLYER CARD',
  detail: 'FrequentFlyerCard number  64827862 is not found in database or does not match the name of traveler',
  type: 'error',
  id: '1'
};

export const mockErrorUniqueFrequentFlyerCard: ErrorMessage = {
  code: '36804',
  title: 'TOO MANY ELEMENTS OF A GIVEN TYPE',
  detail: 'Too many elements of a Given type',
  type: 'error',
  id: '1'
};

export const frequentFlyerCardWithTierDetails: FrequentFlyerCard = createFrequentFlyerCard({
  template: {
    travelerId: namedTraveler.id,
    id: '11111111',
    alliancePriorityCode: '2',
    allianceTierLevel: 'S',
    allianceTierLevelName: 'Silver',
    cardNumber: '020052911',
    companyCode: 'SV',
    tierLevel: 'SILV',
    tierLevelName: 'MILES&GO SILVER'
  }
});
